/**
 * The URL segment the Open Items tab lives at inside a Clarity domain workspace:
 * `/clarity/d/:domainId/open-items`.
 *
 * Shared because two layers already declare this literal privately, and each one's own comment
 * says it must stay identical to the other's: the application's route table
 * (`CLARITY_OPEN_ITEMS_PATH` in `clarity.routes.ts`) and the shell's Control Center tab registry
 * (`OPEN_ITEMS_PATH`, where a tab's `id` IS its URL segment). `type:util` is the one layer both
 * may reach, so a consumer that needs the segment has a declaration to import rather than a third
 * copy to keep in step.
 *
 * A drift between them fails silently rather than loudly: the strip's link and the route that
 * answers it stop being one string, and a URL matching no registered link renders an empty page
 * instead of throwing.
 */
export const CLARITY_OPEN_ITEMS_ROUTE_SEGMENT = 'open-items';
